import React,{useEffect,useState} from "react";
import { useSearchParams, useNavigate, useLocation} from "react-router-dom";
import Layout from "./components/Layout"
import { AuthProvider, AuthConsumer } from "./components/trustBuilder/Auth/authProvider"
import Services from "./components/trustBuilder/Services/Services";
import environmntConfig from "./components/trustBuilder/constants/envconstants"
import jwt_decode from 'jwt-decode';
import { SERVER } from './constants/networkUrls';
import './App.css'; 
import './fonts/lineto-circular-medium.ttf';
import './fonts/lineto-circular-book.ttf';
import InitialLoginPage from './components/initialPage/initialLoginPage.js';
import {ASSET_FORM_TYPE,SPACE_FORM_TYPE} from './constants/stringConstants';
import axios from 'axios';
import apiConfig from './components/trustBuilder/Auth/services/apiConfig';
import Loader from './layouts/loader/index';
import {setGUIDCookie} from './components/fmstransactions/guidTrack';
import {fmsSessionTrack} from './components/fmstransactions/fmsTrackCount'
import { getStoredLoginSelection, clearLoginSelection,closeAuthenticationTab,getNMBSLoadingSelection } from "./components/storage/selectionStorage.js";
import { getQRSession, clearQRSessionId,getQRSessionId,getQRSessionforAuthorized } from './components/qrcode/qrcodeAuditlog.js';
import {getQRCodeAuthToken} from './components/qrcode/qrauthorization.js';
import { extractAuthCode } from './utilities/authCodeExtractor';
import configuration from "./configuration.json";
import AuthFlowGate from "./components/auth/AuthFlowGate";

// Entra ID imports
import { loginRequest, msalConfig } from "./components/entraId/entraauthConfig";
import { createPKCECodes, generateRandomString } from "./components/entraId/pkce";

const PKCE_VERIFIER_STORAGE_KEY = "pkce_code_verifier";
const OAUTH_STATE_STORAGE_KEY = "oauth_state";
const AUTH_FLOWS = {
  TRUSTBUILDER: "TRUSTBUILDER",
  ENTRA: "ENTRA"
};
const CODE_EXCHANGE_COMPLETED_KEY = "code_exchange_completed";
const ENTRA_REDIRECT_IN_PROGRESS_KEY = "entra_redirect_in_progress";
const COMPACT_JWT_PATTERN = /^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/;

const resolveAuthFlow = () => {
  const configuredFlow = String(configuration?.authProvider || AUTH_FLOWS.TRUSTBUILDER).toUpperCase();
  return configuredFlow === AUTH_FLOWS.ENTRA ? AUTH_FLOWS.ENTRA : AUTH_FLOWS.TRUSTBUILDER;
};

function App() {
  let idToken = localStorage.getItem("IdentityToken");
  let firstPopup = localStorage.getItem("FirstPopup");
  let isInitialLoginStored =  JSON.parse(localStorage.getItem("InitialLogin"));
  let isNMBSEmployeeLoginNeeded = JSON.parse(localStorage.getItem("isNMBSEmployeeLoginNeeded"));

  const [isLoading,setIsLoading] = useState(false);
  const [isSiteRestricted,setisSiteRestricted] = useState(false);
  const [qrsessionId,setQrSessionId] = useState("");
  const isTokenExchangeInProgressRef = React.useRef(false);
  const exchangedAuthCodeRef = React.useRef(null);

  if(idToken === "null"){
    idToken = null
  }

  
  if(idToken === null){
    console.log("Entered into Null");
  }else{
    console.log("Entered into idToken not Null");

    try {
      let identity_token_decode = jwt_decode(idToken);
      console.log("identity_token_decode in Expiry Logic",JSON.stringify(identity_token_decode));
      console.log("token exp in Expiry Logic",JSON.stringify(identity_token_decode.exp));
      console.log("Token Exp ",identity_token_decode.exp);
      let applicationTimeStamp = Math.floor((new Date()).getTime() / 1000);
      console.log("Application Time exp in Expiry Logic",applicationTimeStamp);
      if(identity_token_decode.exp<applicationTimeStamp){
        console.log("Decode Token is greater logic");
        idToken = null;
        localStorage.removeItem("IdentityToken");
        localStorage.removeItem("code");
        localStorage.removeItem(CODE_EXCHANGE_COMPLETED_KEY);
        localStorage.removeItem(ENTRA_REDIRECT_IN_PROGRESS_KEY);

      }
    } catch (error) {
      console.warn("Invalid IdentityToken found in storage. Clearing token.", error);
      idToken = null;
      localStorage.removeItem("IdentityToken");
      localStorage.removeItem("code");
      localStorage.removeItem(CODE_EXCHANGE_COMPLETED_KEY);
      localStorage.removeItem(ENTRA_REDIRECT_IN_PROGRESS_KEY);
    }
  }
  const isInitialPath = localStorage.getItem("initialPath")
  
  const configuredAuthFlow = React.useMemo(() => resolveAuthFlow(), []);

  const initiateEntraSigninRedirect = React.useCallback(async () => {
    const isCallbackPath = (window?.location?.pathname || "").split("/").includes("callback");
    const hasIdentityToken = Boolean(localStorage.getItem("IdentityToken"));
    const hasPendingAuthCode = Boolean(localStorage.getItem("code"));
    const isRedirectLocked = localStorage.getItem(ENTRA_REDIRECT_IN_PROGRESS_KEY) === "true";

    console.log("[ENTRA] initiateEntraSigninRedirect called", {
      isCallbackPath,
      hasIdentityToken,
      hasPendingAuthCode,
      isRedirectLocked
    });

    if (isCallbackPath || hasIdentityToken || hasPendingAuthCode || isRedirectLocked) {
      console.log("[ENTRA] Redirect skipped due to active callback/session/lock");
      return;
    }

    const { code_verifier, code_challenge } = await createPKCECodes();
    const state = generateRandomString(32);

    localStorage.setItem(PKCE_VERIFIER_STORAGE_KEY, code_verifier);
    localStorage.setItem(OAUTH_STATE_STORAGE_KEY, state);
    localStorage.setItem(ENTRA_REDIRECT_IN_PROGRESS_KEY, "true");

    const scopes = loginRequest?.scopes?.length ? loginRequest.scopes : ["openid", "profile"];
    const authorizePath = configuration?.authEndpoints?.entraAuthorizePath || "/oauth2/v2.0/authorize";
    const authorizeEndpoint = `${msalConfig.auth.authority}${authorizePath}`;
    const params = new URLSearchParams({
      client_id: msalConfig.auth.clientId,
      redirect_uri: msalConfig.auth.redirectUri,
      response_type: "code",
      response_mode: "query",
      scope: scopes.join(" "),
      code_challenge,
      code_challenge_method: "S256",
      state
    });

    const expectedRedirectUri = `${window.location.origin}/callback`;
    if (msalConfig.auth.redirectUri !== expectedRedirectUri) {
      console.warn("[ENTRA] redirectUri mismatch", {
        configuredRedirectUri: msalConfig.auth.redirectUri,
        expectedRedirectUri
      });
    }

    window.location.assign(`${authorizeEndpoint}?${params.toString()}`);
  }, []);

  

  console.log("isNMBSLogin Initiated and not loggedIn",localStorage.getItem("isNMBSLoginInitiated"));

  console.log("firstPopup initially",firstPopup)
  const [, setFormType] = React.useState(null);
  const [token, setToken] = React.useState(idToken);
  const [trustBuilder,setTrustBuilder] = React.useState(false);
  const [isInitialLoginState,setIsInitialLoginState] =  React.useState(isInitialLoginStored ? isInitialLoginStored : false);
  const [loginType,setLoginType] = React.useState(null); 
  const [searchParams]= useSearchParams();
  const callbackUrl = window?.location?.href || "";
  const isCallbackRoute = (window?.location?.pathname || "").split("/").includes("callback");
  const hashParams = new URLSearchParams((window?.location?.hash || "").replace(/^#/, ""));
  // Only extract code from URL if not already exchanged
  const codeExchangeCompleted = localStorage.getItem(CODE_EXCHANGE_COMPLETED_KEY) === "true";
  const hasIdentityToken = Boolean(idToken || localStorage.getItem("IdentityToken"));
  const shouldReadCodeFromUrl = !codeExchangeCompleted || (isCallbackRoute && !hasIdentityToken);
  const code = shouldReadCodeFromUrl ? (searchParams.get('code') || extractAuthCode(callbackUrl)) : null;
  const state = searchParams.get('state') || hashParams.get('state');
  const hasStoredAuthCode = Boolean(localStorage.getItem("code"));
  const isRedirectLocked = localStorage.getItem(ENTRA_REDIRECT_IN_PROGRESS_KEY) === "true";
  const isRedirectProcessing = isCallbackRoute && (Boolean(code) || hasStoredAuthCode || isRedirectLocked) && !hasIdentityToken;
  const navigate = useNavigate();

  let unsubscribePath = localStorage.getItem("unsubscribePath");

  console.log("configuration is ",trustBuilder);

  console.log("code and state ",code,state);
  if (isCallbackRoute && code) {
    const expectedState = localStorage.getItem(OAUTH_STATE_STORAGE_KEY);
    if (expectedState && state && expectedState !== state) {
      console.warn("OAuth state mismatch detected. Ignoring callback code.");
      localStorage.removeItem("code");
      localStorage.removeItem("state");
      localStorage.removeItem(ENTRA_REDIRECT_IN_PROGRESS_KEY);
    } else {
      localStorage.setItem("code", code);
      localStorage.setItem("state", state);

      const storedVerifier = localStorage.getItem(PKCE_VERIFIER_STORAGE_KEY);
      console.log("=== PKCE Callback — values for .NET token exchange ===");
      console.log("auth_code    :", code);
      console.log("code_verifier:", storedVerifier);
      console.log("redirect_uri :", window.location.origin + "/callback");
      console.log("======================================================");
    }
  }

  const hostname = window?.location?.hostname;
  const environmentConstants = apiConfig.setEnvironmentURLs(hostname);

  const getUserRoles = () => {
    const IdentityToken = localStorage.getItem("IdentityToken");
    if(IdentityToken){
      try {
        let decoded_token = jwt_decode(IdentityToken);
        console.log("decoded_token is",JSON.stringify(decoded_token));
      } catch (error) {
        console.warn("IdentityToken is not a decodable JWT.", error);
      }
      let redirectUri = localStorage.getItem("initialPath")
      console.log("redirectUri is",redirectUri);
      if (redirectUri) {
        navigate(redirectUri, { replace: true });
        localStorage.removeItem("initialPath");
        localStorage.setItem("isNMBSLoginInitiated","false");
        console.log("Entered into closeAuthenticationTab");
        localStorage.setItem("trustBuilder",true);
        closeAuthenticationTab();
      } else if (isCallbackRoute) {
        // If no initialPath is set but we're on callback route, navigate to home to clear the URL
        console.log("Navigating away from callback route");
        localStorage.setItem("isNMBSLoginInitiated","false");
        navigate("/", { replace: true });
      }
    }
  }

 

  const location = useLocation();

 
  useEffect(() => {  
      window.onpageshow = function(event) {
        if (event.persisted) {
            console.log(" ***** Entered into window reload");
            window.location.reload();
        }
      }; 
 },[]);

 useEffect(()=>{
  console.log("isNMBSEmployeeLoginNeeded entered",isNMBSEmployeeLoginNeeded)
  if(isNMBSEmployeeLoginNeeded === true){
    // loginTypeCheck("NMBS_EMPLOYEE")
    setIsInitialLoginState(false);
    setToken(null);
    localStorage.setItem("InitialLogin",false);
    localStorage.setItem("isNMBSLoginInitiated",true)
    localStorage.setItem("trustBuilder",true);
    setTrustBuilder(true);
    localStorage.setItem("isNMBSEmployeeLoginNeeded",false);
  }
 },[isNMBSEmployeeLoginNeeded])

 useEffect(() => {
  window.history.pushState(null, document.title, window.location.href);
  window.addEventListener('popstate', function(event) {
    window.history.pushState(null, document.title, window.location.href);
  });
}, [location]);
 

  let pathName = window?.location?.pathname;

  console.log("pathName in useEffect",pathName);
  let pathNameObjArray = pathName?.split("/");
  console.log("pathNameObjArray is",pathNameObjArray)
  let assetId = pathNameObjArray && pathNameObjArray[pathNameObjArray.length-1];
  
 

  if(pathNameObjArray.includes("facility-asset") || (pathNameObjArray.includes("facility-space")) || pathNameObjArray.includes("qrcode")){
    console.log("initialPath set to",pathName)
    localStorage.setItem("initialPath", pathName);
    localStorage.removeItem("unsubscribePath");
  }else if((pathNameObjArray.includes("unsubscribe")) ){
    console.log("initialPath set to",pathName)
    localStorage.setItem("initialPath", pathName);
  } 

  if((pathNameObjArray.includes("unsubscribe"))){
    localStorage.setItem("unsubscribePath", pathName);
  }

 
 
  const getURLforForm = () => {
    const pathInitial = localStorage.getItem("initialPath");
    const formPathArray = pathInitial?.split("/") || [];
    const assetSpaceId = formPathArray.at(-1);

    if (!assetSpaceId) {
      return null;
    }

		return formPathArray.includes("facility-asset") ? `${SERVER.API_BASE_URL}${SERVER.SERVICES.getAssetDetails}${assetSpaceId}` : `${SERVER.API_BASE_URL}${SERVER.SERVICES.getSpaceDetails}${assetSpaceId}`
	}

  const getFormDetailsFromAPI = async (apiUrl) => { 
    setIsLoading(true)
    console.log("environmentConstants.apiKey",environmentConstants.apiKey);

    let authConfig = {
        headers:{
            "X-API-KEY" :environmentConstants.apiKey
        }
}
   


     
   axios.get(apiUrl, authConfig)
  .then((response) => {

    const assetResponse = response.data;
    const isSuccess = response.status === 200 && assetResponse?.complaints !== null;

    if (!isSuccess) {
      console.warn("Entered into server down flow - status:", response.status);
      localStorage.removeItem("assetData");
      navigate("/serverDown", { state: { statusCode: 100 } });
      return null;
    }

    if (assetResponse.complaints.length === 0) {
      navigate("/serverDown", { state: { statusCode: 404 } });
      setIsLoading(false);
      return assetResponse;
    }

    console.log("assetResponse", assetResponse);

    localStorage.setItem("assetData", JSON.stringify(assetResponse));
    setGUIDCookie(assetResponse.sessionId);

    const storedTrustBuilderValue = JSON.parse(localStorage.getItem("trustBuilder"));

    const isRestricted = assetResponse.isSiteRestricted;
    const isPrivate = assetResponse.isPrivate;

    setisSiteRestricted(isRestricted);

    const trustBuilderValue = isRestricted || storedTrustBuilderValue;

    localStorage.setItem("trustBuilder", trustBuilderValue);
    setTrustBuilder(trustBuilderValue);

    if (isRestricted && configuredAuthFlow === AUTH_FLOWS.ENTRA) {
      localStorage.removeItem("code");
      localStorage.removeItem("state");
      localStorage.removeItem(PKCE_VERIFIER_STORAGE_KEY);
      localStorage.removeItem(OAUTH_STATE_STORAGE_KEY);
      localStorage.removeItem(CODE_EXCHANGE_COMPLETED_KEY);
      localStorage.removeItem(ENTRA_REDIRECT_IN_PROGRESS_KEY);
      localStorage.setItem("isNMBSLoginInitiated", "true");
      initiateEntraSigninRedirect();
    }

    localStorage.setItem("isPrivate", isPrivate ? "true" : "false");

    if (!isRestricted && !isPrivate) {
      console.log("Entering into code remove block");
      localStorage.removeItem("IdentityToken");
      localStorage.removeItem("code");
    }
    setIsLoading(false);

    return assetResponse;
  })
  .catch((error) => {
    setIsLoading(false);
    localStorage.removeItem("assetData");

    const statusCode = error.response?.status || 100;
    console.error("server down catch block", error);

    navigate("/serverDown", { state: { statusCode } });

    return error;
  });


} 

  useEffect(() =>  {
    let isNMBSLoginInitiated = localStorage.getItem("isNMBSLoginInitiated");
    console.log("isNMBSLoginInitiated is",isNMBSLoginInitiated);
    let baseUrl = `${window.location.origin}/`
    console.log("Get space Details API calling logic",unsubscribePath,window.location.href)
    const storedLoginSelection = getNMBSLoadingSelection();
     if(!storedLoginSelection){
      console.log("API is called in useEffect===")
      if(!window.location.href.includes("unsubscribe") && !window.location.href.includes("verify") && baseUrl != window.location.href && !window.location.href.includes("maintenance") && !pathNameObjArray.includes("callback")&& !pathNameObjArray.includes("qrcode") && !pathNameObjArray.includes("local")){
          const formApiUrl = getURLforForm();
          if (formApiUrl) {
            getFormDetailsFromAPI(formApiUrl);
          } else {
            console.warn("Skipping form API call because asset/space id is missing.");
            setIsLoading(false);
          }
      }
     }
  },[])

  useEffect(()=>{
    let baseUrl = `${window.location.origin}/`
    let serverDown = `${window.location.origin}/serverDown`


    if(baseUrl === window.location.href || window.location.origin === window.location.href || serverDown === window.location.href || pathNameObjArray.includes("callback")){
      console.log("Entered into Base URL");
      setIsInitialLoginState(false);
      setTrustBuilder(false);
    }

    if(pathNameObjArray.includes("qrcode")){
      console.log("useEffect under baseURL");
      localStorage.setItem("initialPath", pathName);  
    }

    if(isInitialPath !== null){
      if(isInitialPath.includes("facility-asset")){
        console.log("Initital Path set to refresh view");
        setFormType(ASSET_FORM_TYPE);
      }else if((isInitialPath.includes("facility-space"))){
        console.log("Initital Path set to refresh view");
        setFormType(SPACE_FORM_TYPE);
      }else if((isInitialPath.includes("unsubscribe")) ){
        console.log("Initital Path set to refresh view");
        setFormType(null);
      }
    }
   
   

      if(pathNameObjArray.includes("facility-asset")){
        console.log("initialPath set to",pathName)
        localStorage.setItem("initialPath", pathName);
        setFormType(ASSET_FORM_TYPE);
        loginType == null &&  setIsInitialLoginState(true);
      }else if((pathNameObjArray.includes("facility-space"))){
        console.log("initialPath set to",pathName)
        localStorage.setItem("initialPath", pathName);
        setFormType(SPACE_FORM_TYPE);
        loginType == null &&  setIsInitialLoginState(true);
      }else if((pathNameObjArray.includes("unsubscribe")) || (pathNameObjArray.includes("qrcode"))){
        console.log("initialPath set to",pathName)
        localStorage.setItem("initialPath", pathName);
        setFormType(null);
      }
      else if((pathNameObjArray.includes("submitted")) ){
        console.log("initialPath set to",pathName)
        setIsInitialLoginState(false)
        setTrustBuilder(false);
        setToken(null)
      }
      if(isNMBSEmployeeLoginNeeded === true){
        console.log("initialPath set to",pathName)
        setIsInitialLoginState(false)
        setTrustBuilder(true);
        setToken(null)
      }

      
  

  },[assetId,trustBuilder,token])
  
  useEffect(()=>{
    console.log("Enetered into the useEffect to call new qrsession API")
    if(idToken){
      try {
        let identity_token_decode = jwt_decode(idToken);
        console.log("idToken after authorized",identity_token_decode,identity_token_decode.sub);
        getQRSessionforAuthorized(identity_token_decode.sub)
      } catch (error) {
        console.warn("Unable to decode IdentityToken for QR session authorization.", error);
      }
    }
  },[qrsessionId])
  
  useEffect(()=>{
    if(pathNameObjArray.includes("qrcode")){
      console.log("useEffect under baseURL");
      localStorage.setItem("initialPath", pathName);
      clearQRSessionId();
    getQRSession(false)
     
  .then(response => {
    console.log("Success:", response);
    setQrSessionId(response);

  })
  .catch(error => {
    console.error("Error:", error);
    setQrSessionId(null);
    localStorage.setItem("qrcodeAuthorized", "false");

     navigate("/qrcode");
     
  });
    }

  },[])


    // Uncomment this for only localhost
    useEffect(()=>{
      if(trustBuilder == true){
        if (environmntConfig.customToken){
          localStorage.setItem("code", environmntConfig.code);
          localStorage.setItem("state", environmntConfig.state);
          localStorage.setItem("IdentityToken", environmntConfig.IdentityToken);
          localStorage.setItem("refreshToken", environmntConfig.refreshToken);
          localStorage.setItem("languageCode",environmntConfig.language);
          getUserRoles();
        }
      }
     
    },[])

  const authCodeFromStorage = localStorage.getItem("code");
  const authCode = code || (isCallbackRoute ? authCodeFromStorage : null);

  const normalizeAuthResponse = (authResponse) => {
    if (!authResponse) {
      return null;
    }

    const rawToken = authResponse.IdentityToken || authResponse.identityToken || authResponse.idToken || authResponse.accessToken || authResponse.access_token;
    if (!rawToken) {
      return null;
    }

    const normalizedToken = String(rawToken).replace(/^Bearer\s+/i, "").trim();
    if (!COMPACT_JWT_PATTERN.test(normalizedToken)) {
      return null;
    }
    const refreshToken = authResponse.refreshToken || authResponse.refresh_token || "";

    return {
      ...authResponse,
      IdentityToken: normalizedToken,
      refreshToken
    };
  };

  const applyAuthTokens = async (authResponse) => {
    const normalizedResponse = normalizeAuthResponse(authResponse);

    if (normalizedResponse?.IdentityToken) {
      // Mark code exchange as completed to prevent infinite loop
      localStorage.setItem(CODE_EXCHANGE_COMPLETED_KEY, "true");
      localStorage.removeItem(ENTRA_REDIRECT_IN_PROGRESS_KEY);
      localStorage.removeItem(PKCE_VERIFIER_STORAGE_KEY);
      localStorage.removeItem(OAUTH_STATE_STORAGE_KEY);
      localStorage.removeItem("code");
      localStorage.removeItem("state");
      setToken(normalizedResponse.IdentityToken);
      localStorage.setItem("TOKEN", normalizedResponse.IdentityToken);
      await Services.setAuthToken(normalizedResponse);
      getUserRoles();
      return true;
    }

    return false;
  };

  const exchangeAuthCodeForToken = async (codeValue) => {
    if (configuredAuthFlow === AUTH_FLOWS.ENTRA) {
      const codeVerifier = localStorage.getItem(PKCE_VERIFIER_STORAGE_KEY) || "";
      const entraTokenUrl = `${SERVER.API_BASE_URL}${SERVER.SERVICES.GENERATE_ENTRA_TOKEN}`;

      const response = await axios.post(
        entraTokenUrl,
        {
          authCode: codeValue,
          codeVerifier
        },
        {
          headers: {
            "X-API-KEY" :environmentConstants.apiKey
          }
        }
      );

      return response?.data;
    }

    const getAuthURL = `${SERVER.API_BASE_URL}${SERVER.SERVICES.GENERATE_TOKEN}${codeValue}`;
    const response = await Services.getAuthToken(getAuthURL);
    return response?.data;
  };

  const fetchQRAuthToken = async () => {
    let sessionId = getQRSessionId();
    console.log("sessionId is", sessionId);
    const authCode = localStorage.getItem("code");
    console.log("authCode qrSessionId", authCode, sessionId);

    if (!authCode) {
      localStorage.setItem("isNMBSLoginInitiated", "false");
      localStorage.setItem("qrcodeAuthorized", "false");
      localStorage.setItem("qrcodeAuthFailed", "true");
      return;
    }

    if (!sessionId) {
      try {
        await getQRSession(false);
        sessionId = getQRSessionId();
      } catch (sessionError) {
        console.error("Failure: unable to create QR session", sessionError);
      }
    }

    if (!sessionId) {
      localStorage.setItem("isNMBSLoginInitiated", "false");
      localStorage.setItem("qrcodeAuthorized", "false");
      localStorage.setItem("qrcodeAuthFailed", "true");
      return;
    }

    try {
      const response = await getQRCodeAuthToken(authCode, sessionId);
      console.log("Success:", response.data);
      const normalizedResponse = normalizeAuthResponse(response.data);
      if (normalizedResponse?.IdentityToken) {
        await applyAuthTokens(normalizedResponse);
        localStorage.setItem("isNMBSLoginInitiated", "false");
        localStorage.setItem("qrcodeAuthorized", "true");
        localStorage.removeItem("qrcodeAuthFailed");
        window.dispatchEvent(new Event("authChanged"));
      }else {
        console.log("QR auth response has no token. Falling back to standard token exchange.");
        const fallbackAuthResponse = await exchangeAuthCodeForToken(authCode);
        const fallbackSuccess = await applyAuthTokens(fallbackAuthResponse);

        localStorage.setItem("isNMBSLoginInitiated", "false");

        if (fallbackSuccess) {
          // Keep QR endpoint authorization semantic: missing QR token means no QR entitlement.
          localStorage.setItem("qrcodeAuthorized", "false");
          localStorage.setItem("qrcodeAuthFailed", "true");
          window.dispatchEvent(new Event("authChanged"));
          navigate("/qrcode");
          return;
        }

        localStorage.setItem("qrcodeAuthorized", "false");
        localStorage.setItem("qrcodeAuthFailed", "true");
        window.dispatchEvent(new Event("authChanged"));
        navigate("/qrcode");
        console.log("Entered into Remove AuthData ServerDown");
        Services.removeAuthData();
      }
    } catch (error) {
      console.error("Failure: in QRCode", error);
      localStorage.setItem("isNMBSLoginInitiated", "false");
      localStorage.setItem("qrcodeAuthorized", "false");
      localStorage.setItem("qrcodeAuthFailed", "true");
      window.dispatchEvent(new Event("authChanged"));

      navigate("/qrcode");
    }
  };

  useEffect(() => {
    const handleTokenExchange = async () => {
      const currentAuthCode = localStorage.getItem("code");
      const isNMBSLoginInitiated = localStorage.getItem("isNMBSLoginInitiated") === "true";
      const hasAuthGateEnabled = localStorage.getItem("trustBuilder") === "true";
      const redirectUri = localStorage.getItem("initialPath") || "";

      console.log("authCode and idToken", currentAuthCode, idToken);

      if (!isCallbackRoute) {
        console.log("Skipping token exchange: not in callback route");
        return;
      }

      if (!currentAuthCode || idToken) {
        return;
      }

      if (!isNMBSLoginInitiated && !hasAuthGateEnabled) {
        console.log("Skipping token exchange: NMBS login not initiated");
        return;
      }

      if (isTokenExchangeInProgressRef.current || exchangedAuthCodeRef.current == currentAuthCode) {
        console.log("Skipping duplicate token exchange attempt");
        return;
      }

      if (redirectUri.includes("qrcode")) {
        fetchQRAuthToken();
        return;
      }

      try {
        isTokenExchangeInProgressRef.current = true;
        exchangedAuthCodeRef.current = currentAuthCode;
        const authResponse = await exchangeAuthCodeForToken(currentAuthCode);
        const isSuccess = await applyAuthTokens(authResponse);

        if (!isSuccess) {
          console.log("came into else loop as data is null");
          localStorage.removeItem(ENTRA_REDIRECT_IN_PROGRESS_KEY);
          navigate("/serverDown",{state:{ statusCode: 100 }});
          console.log("Entered into Remove AuthData ServerDown");
          Services.removeAuthData();
        }
      } catch (err) {
        exchangedAuthCodeRef.current = null;
        localStorage.removeItem(ENTRA_REDIRECT_IN_PROGRESS_KEY);
        console.log("err in the GetAuth API", err);
        navigate("/serverDown",{state:{ statusCode: 100 }});
        console.log("Entered into Remove AuthData in catch");
        Services.removeAuthData();
      } finally {
        isTokenExchangeInProgressRef.current = false;
      }
    };

    handleTokenExchange();
  }, [authCode, idToken, configuredAuthFlow, isCallbackRoute]);

  useEffect(() => {
    if (!isCallbackRoute && hasIdentityToken) {
      localStorage.removeItem(ENTRA_REDIRECT_IN_PROGRESS_KEY);
    }
  }, [hasIdentityToken, isCallbackRoute]);

  console.log("unsubscribePath value",unsubscribePath);
  console.log("FirstPopup value",firstPopup);
  console.log("idToken value",idToken);
  
  const loginTypeCheck = (type) =>{
    console.log("type is",type);
    setIsInitialLoginState(false);
    setLoginType(type);
    setToken(null);
    localStorage.setItem("InitialLogin",false);
    fmsSessionTrack(type === "VISITOR" ? "Traveller" :"NMBSUser",false);
    localStorage.setItem("trustBuilder",type === "VISITOR" ? false : true);
    
    if(type === "VISITOR"){
      localStorage.setItem("isNMBSLoginInitiated",false)
      localStorage.removeItem(ENTRA_REDIRECT_IN_PROGRESS_KEY);
      setTrustBuilder(false);
    }else{
      // Clear stale auth artifacts so AuthFlowGate always redirects first.
      localStorage.removeItem("code");
      localStorage.removeItem("state");
      localStorage.removeItem(PKCE_VERIFIER_STORAGE_KEY);
      localStorage.removeItem(OAUTH_STATE_STORAGE_KEY);
      localStorage.removeItem(CODE_EXCHANGE_COMPLETED_KEY);
      localStorage.removeItem(ENTRA_REDIRECT_IN_PROGRESS_KEY);
      localStorage.setItem("isNMBSLoginInitiated",true)
      setTrustBuilder(true);
      localStorage.removeItem("IdentityToken");
      localStorage.removeItem("refreshToken");
    }
  }

  const showLoginOptionPage = () => {
    console.log("idToken isInitialLoginState unsubscribePath isSiteRestricted",idToken,isInitialLoginState,unsubscribePath,isSiteRestricted)
    if(idToken === null && isInitialLoginState && !unsubscribePath && !isSiteRestricted && !pathNameObjArray.includes("submitted")){
      return true;
    }
    return false  
  }



  const showTrustbuilderPage = () => {
    const storedLoginSelection = getStoredLoginSelection();
    const isAuthenticatedSelection = loginType == "NMBS_EMPLOYEE";

    if((isSiteRestricted || trustBuilder || token || storedLoginSelection || authCode || isAuthenticatedSelection) && !pathNameObjArray.includes("submitted")){
      console.log("Entered into trustbuilder show logic");
      clearLoginSelection();
      return true
    }
    return false
  }
  
  console.log("Window history",window.history);

  const shouldShowLoginOptionPage = showLoginOptionPage();
  const shouldShowAuthPage = showTrustbuilderPage();
  const isNMBSLoginInitiated = localStorage.getItem("isNMBSLoginInitiated") === "true";
  const shouldForceRestrictedEntra = configuredAuthFlow === AUTH_FLOWS.ENTRA && isSiteRestricted;
  const shouldTriggerEntraRedirect =
    configuredAuthFlow === AUTH_FLOWS.ENTRA &&
    (isNMBSLoginInitiated || shouldForceRestrictedEntra) &&
    !hasIdentityToken &&
    !isCallbackRoute &&
    !hasStoredAuthCode &&
    !isRedirectLocked &&
    !isRedirectProcessing;

  let content = <Layout/>;

  if (shouldShowLoginOptionPage) {
    content = <InitialLoginPage loginTypeCallback={loginTypeCheck}/>;
  } else if (shouldShowAuthPage) {
    if (configuredAuthFlow === AUTH_FLOWS.ENTRA) {
      content = (
        <AuthFlowGate
          authCode={authCode}
          authFlow={configuredAuthFlow}
          hasSession={hasIdentityToken}
          isCallbackRoute={isCallbackRoute}
          isRedirectProcessing={isRedirectProcessing}
          shouldTriggerRedirect={shouldTriggerEntraRedirect}
          onEntraRedirect={initiateEntraSigninRedirect}
        />
      );
    } else {
      content = (
        <AuthProvider>
          <AuthConsumer>
            {({ signinRedirect}) => (
              <AuthFlowGate
                authCode={authCode}
                authFlow={configuredAuthFlow}
                hasSession={Boolean(token)}
                isCallbackRoute={isCallbackRoute}
                isRedirectProcessing={false}
                shouldTriggerRedirect={true}
                onTrustBuilderRedirect={signinRedirect}
              />
            )}
          </AuthConsumer>
        </AuthProvider>
      );
    }
  }

  return isLoading ? <Loader/> : content;
}

export default App;